import moment from 'moment';

export default class RosterItem {
  constructor(type, start, end, hasActuals) {
    this.type = type;
    this.start = start;
    this.end = end;
    this.hasActuals = hasActuals;
  }

  allHaveActuals() {
    return this.hasActuals;
  }

  getType() {
    return this.type;
  }

  mergeWith(rosterItem) {
    this.start = moment.min(rosterItem.start, this.start);
    this.end = moment.max(rosterItem.end, this.end);
  }

  sort() {
    // Do nothing by default
  }

  shouldBeRemoved() {
    return false;
  }

  overlapsWith(rosterItem) {
    return rosterItem.start.isBefore(this.end) && rosterItem.end.isAfter(this.start);
  }

  canBeMerged(rosterItem) {
    return (
      rosterItem.type === this.type &&
      rosterItem.start.isSameOrBefore(this.end) &&
      rosterItem.end.isSameOrAfter(this.start)
    );
  }
}
